import { useEffect } from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Datenschutz() {
  useEffect(() => {
    document.title = "Datenschutzerklärung – Dickies-Campus GmbH";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream-50">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-24">
        <span className="eyebrow">Rechtliches</span>
        <h1 className="mt-3 font-heading text-4xl md:text-5xl font-semibold text-sand-800 tracking-tight mb-3">
          Datenschutzerklärung
        </h1>
        <p className="text-sand-600 mb-10 text-sm">
          Gültig für dickies-helden.de und den Dickies-Campus.
        </p>

        <section className="space-y-8 text-sand-700 text-[15px] leading-[1.7]">
          <p>
            Wir nehmen den Schutz deiner personenbezogenen Daten sehr ernst und behandeln sie vertraulich und entsprechend
            den gesetzlichen Datenschutzvorschriften (DSGVO, BDSG, TDDDG) sowie dieser Datenschutzerklärung. Diese Erklärung
            gilt für unsere Website, das Buchungs- und Kursportal sowie den geschützten Mitglieder-Bereich
            („Dickies-Campus&quot;).
          </p>

          {/* 1. Verantwortliche Stelle */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">1. Verantwortliche Stelle</h2>
            <p>
              Dickies-Campus GmbH<br />
              Neuenhausplatz 73, 40699 Erkrath<br />
              E-Mail: <a href="mailto:info@dickies-helden.de" className="underline hover:text-sand-800">info@dickies-helden.de</a><br />
              Telefon: <a href="tel:+4921129273330" className="underline hover:text-sand-800">0211 29273330</a>
            </p>
            <p className="mt-3 text-sm text-sand-600">
              Datenschutzbeauftragter:in: Anfragen bitte an die oben genannte E-Mail mit dem Betreff &bdquo;Datenschutz&ldquo;.
            </p>
          </div>

          {/* 2. Kategorien personenbezogener Daten */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">2. Welche Daten wir verarbeiten</h2>
            <p>Je nachdem, wie du mit uns interagierst, verarbeiten wir folgende Kategorien personenbezogener Daten:</p>
            <ul className="mt-3 list-disc pl-5 space-y-1.5">
              <li><b>Kontaktanfragen &amp; Beratung:</b> Name, E-Mail-Adresse, Telefonnummer, Kursinteresse, Nachricht.</li>
              <li><b>Kursbuchung &amp; Vertragsabwicklung:</b> Name, Anschrift, Geburtsdatum, ggf. Bildungsgutschein-Nummer, Zahlungsinformationen, Teilnahmehistorie, Zertifikatsdaten.</li>
              <li><b>Dickies-Campus-Konto:</b> E-Mail-Adresse, Passwort (verschlüsselt gespeichert mittels bcrypt), Anzeigename, berufliche Rolle, Einrichtung (freiwillig), Mitglieds-Tier.</li>
              <li><b>Community-Beiträge (#mdk-lagezentrum):</b> von dir verfasste Beiträge, Reaktionen und Kommentare.</li>
              <li><b>Lead-Magnet-Downloads:</b> E-Mail-Adresse, Vorname (optional), Rolle, Einwilligungsstatus, Quelle des Downloads.</li>
              <li><b>Nutzungsdaten:</b> Anmeldezeitpunkte, aufgerufene Inhalte des Campus, Download-Aktivitäten — ausschließlich zum Schutz vor Missbrauch und zur Verbesserung des Dienstes.</li>
              <li><b>Technische Daten:</b> IP-Adresse (anonymisiert), Browser, Betriebssystem, Zugriffszeit.</li>
            </ul>
          </div>

          {/* 3. Rechtsgrundlagen */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">3. Rechtsgrundlagen der Verarbeitung</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li><b>Art. 6 Abs. 1 lit. a DSGVO</b> – Einwilligung (z. B. Newsletter, Lead-Magnet-Downloads, Cookies, die nicht technisch erforderlich sind).</li>
              <li><b>Art. 6 Abs. 1 lit. b DSGVO</b> – Vertragserfüllung und vorvertragliche Maßnahmen (Kursbuchung, Campus-Mitgliedschaft, Beratungsanfragen).</li>
              <li><b>Art. 6 Abs. 1 lit. c DSGVO</b> – Erfüllung gesetzlicher Pflichten (steuer-, handels- und förderrechtliche Aufbewahrung).</li>
              <li><b>Art. 6 Abs. 1 lit. f DSGVO</b> – Berechtigtes Interesse (Sicherheit, Missbrauchsschutz, Reichweitenmessung in anonymisierter Form).</li>
            </ul>
          </div>

          {/* 4. Dickies-Campus Mitgliedschaft */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">4. Dickies-Campus – Mitglieder-Bereich</h2>
            <p>
              Für die Nutzung des Dickies-Campus ist die Erstellung eines Nutzerkontos erforderlich. Die Anmeldung erfolgt über
              E-Mail-Adresse und Passwort. Wir speichern dein Passwort niemals im Klartext, sondern ausschließlich als
              kryptografischen Hash (bcrypt). Authentifizierungs-Tokens (JWT) werden in einem sicheren HTTPS-Only-Cookie
              hinterlegt und verfallen nach 14 Tagen Inaktivität.
            </p>
            <p className="mt-3">
              Beiträge im <i>#mdk-lagezentrum</i> und im Community-Forum werden mit deinem Anzeigenamen und deiner Rolle
              veröffentlicht. Diese Beiträge sind für alle eingeloggten Mitglieder sichtbar und werden nicht öffentlich
              indexiert. Du kannst eigene Beiträge jederzeit löschen lassen (Mail an info@dickies-helden.de).
            </p>
            <p className="mt-3">
              Bei Kündigung deiner Mitgliedschaft wird dein Konto innerhalb von 30 Tagen anonymisiert oder gelöscht, sofern
              keine gesetzlichen Aufbewahrungspflichten entgegenstehen (z. B. Rechnungsdaten 10 Jahre nach § 147 AO).
            </p>
          </div>

          {/* 5. Zahlungen */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">5. Zahlungen über Stripe</h2>
            <p>
              Für die Online-Zahlung (Kursbuchungen, eBook-Käufe und – sofern aktiv – Campus-Abonnements) nutzen wir den
              Zahlungsdienstleister Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin,
              Irland (&bdquo;Stripe&ldquo;). Die für die Zahlung erforderlichen Daten (z. B. Name, Zahlungsdaten) werden direkt an Stripe
              übermittelt. Wir selbst speichern keine vollständigen Zahlungsdaten. Rechtsgrundlage: Art. 6 Abs. 1 lit. b
              DSGVO. Datenschutzerklärung von Stripe:{" "}
              <a href="https://stripe.com/de/privacy" target="_blank" rel="noreferrer" className="underline hover:text-sand-800">stripe.com/de/privacy</a>.
            </p>
          </div>

          {/* 6. E-Mail-Versand */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">6. E-Mail-Versand (Verifizierung &amp; Service-Mails)</h2>
            <p>
              Für transaktionale E-Mails (Konto-Verifizierung, Passwort-Reset, Buchungsbestätigungen, Lead-Magnet-Downloads,
              Service-Benachrichtigungen aus dem Campus) nutzen wir – sobald aktiviert – den Dienst <b>Resend
              (Resend, Inc., Delaware, USA)</b> oder einen funktional gleichwertigen EU-Anbieter. Eine Datenübermittlung in
              Drittstaaten erfolgt nur auf Grundlage der EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO) und unter
              Beachtung des EU-US Data Privacy Frameworks. Übermittelt werden: E-Mail-Adresse, Anrede, ggf. Inhalt der Mail.
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO.
            </p>
          </div>

          {/* 7. Cookies */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">7. Cookies &amp; lokale Speicherung</h2>
            <p>
              Wir nutzen technisch notwendige Cookies (Session, CSRF-Schutz, Cookie-Banner-Status, Auth-Token) auf Grundlage
              von § 25 Abs. 2 TDDDG. Diese sind für den Betrieb der Website unverzichtbar. Optionale Cookies (z. B. für
              Reichweitenmessung) setzen wir ausschließlich nach deiner ausdrücklichen Einwilligung im Cookie-Banner. Du kannst
              deine Einwilligung jederzeit über den Banner-Link im Footer widerrufen.
            </p>
          </div>

          {/* 8. Google Analytics & Google Ads */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">8. Google Analytics 4 &amp; Google Ads (Consent Mode v2)</h2>
            <p>
              Wir nutzen auf dieser Website Google Analytics 4 (Reichweitenmessung) und Google Ads (Conversion-Messung) der
              Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland (&bdquo;Google&ldquo;). Der Einsatz erfolgt im
              sogenannten <b>Consent Mode v2</b>: Ohne deine Einwilligung ist der Standard &bdquo;denied&ldquo; &ndash; es werden
              keine Cookies gesetzt und keine personenbezogenen Kennungen übermittelt; Google erhält lediglich cookielose,
              anonyme Signale zur Modellierung. Erst mit deiner ausdrücklichen Einwilligung im Cookie-Banner (Art. 6 Abs. 1
              lit. a DSGVO, § 25 Abs. 1 TDDDG) werden Analyse- und Marketing-Cookies aktiviert.
            </p>
            <p className="mt-3">
              IP-Adressen werden von Google Analytics 4 nicht gespeichert und bereits bei der Erhebung gekürzt. Eine
              Übermittlung von Daten in die USA erfolgt auf Grundlage des EU-US Data Privacy Frameworks sowie der
              EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Die Speicherdauer der Analytics-Daten beträgt
              maximal 14 Monate. Du kannst deine Einwilligung jederzeit über den Cookie-Link im Footer mit Wirkung für die
              Zukunft widerrufen. Weitere Informationen: {" "}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="underline hover:text-sand-800">policies.google.com/privacy</a>.
            </p>
          </div>

          {/* 9. Hosting */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">9. Hosting</h2>
            <p>
              Unsere Website und der Dickies-Campus werden bei einem Anbieter mit Server-Standort in der EU gehostet. Mit dem
              Anbieter besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO.
            </p>
          </div>

          {/* 9. Speicherdauer */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">10. Speicherdauer</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li><b>Kontaktanfragen:</b> 6 Monate nach abschließender Bearbeitung, sofern kein Vertrag zustande kommt.</li>
              <li><b>Kursverträge &amp; Rechnungen:</b> 10 Jahre (§ 147 AO).</li>
              <li><b>Lead-Magnet-Daten:</b> Bis zum Widerruf der Einwilligung, max. 24 Monate.</li>
              <li><b>Campus-Konto:</b> Bis zur Kündigung der Mitgliedschaft, danach Löschung innerhalb von 30 Tagen.</li>
              <li><b>Community-Beiträge:</b> Bis zur Löschung durch dich oder zur Kündigung des Kontos.</li>
              <li><b>Server-Logfiles:</b> 14 Tage, danach automatische Löschung.</li>
            </ul>
          </div>

          {/* 10. Empfänger */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">11. Empfänger und Auftragsverarbeiter</h2>
            <p>
              Eine Weitergabe deiner Daten an Dritte erfolgt nur, soweit dies zur Vertragserfüllung erforderlich ist oder du
              ausdrücklich einwilligst. Aktuelle Auftragsverarbeiter:
            </p>
            <ul className="mt-3 list-disc pl-5 space-y-1.5">
              <li>EU-Hosting-Anbieter (technische Bereitstellung)</li>
              <li>Stripe Payments Europe, Ltd. (Zahlungen)</li>
              <li>Resend, Inc. (transaktionale E-Mails) – nach Aktivierung</li>
              <li>MongoDB Atlas (Datenbank, EU-Region)</li>
              <li>Google Ireland Ltd. (Reichweitenmessung &amp; Conversion-Messung – nur nach Einwilligung)</li>
              <li>Agentur für Arbeit (nur bei Bildungsgutschein-Förderung – auf gesetzlicher Grundlage)</li>
            </ul>
          </div>

          {/* 11. Betroffenenrechte */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">12. Deine Rechte als betroffene Person</h2>
            <p>Dir stehen folgende Rechte zu (Art. 15–22 DSGVO):</p>
            <ul className="mt-3 list-disc pl-5 space-y-1.5">
              <li>Auskunft über die zu deiner Person gespeicherten Daten</li>
              <li>Berichtigung unrichtiger Daten</li>
              <li>Löschung („Recht auf Vergessenwerden&quot;)</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
              <li>Widerspruch gegen eine Verarbeitung auf Grundlage berechtigter Interessen</li>
              <li>Widerruf einer einmal erteilten Einwilligung mit Wirkung für die Zukunft</li>
            </ul>
            <p className="mt-3">
              Bitte richte Anfragen formlos an{" "}
              <a href="mailto:info@dickies-helden.de" className="underline hover:text-sand-800">info@dickies-helden.de</a>{" "}
              mit dem Betreff „Datenschutz&quot;.
            </p>
          </div>

          {/* 12. Beschwerderecht */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">13. Beschwerderecht bei der Aufsichtsbehörde</h2>
            <p>
              Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig für uns:
              Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen, Kavalleriestraße 2–4,
              40213 Düsseldorf,{" "}
              <a href="https://www.ldi.nrw.de" target="_blank" rel="noreferrer" className="underline hover:text-sand-800">ldi.nrw.de</a>.
            </p>
          </div>

          {/* 13. Keine automatisierte Entscheidung */}
          <div>
            <h2 className="font-heading text-xl text-sand-800 font-semibold mb-2">14. Keine automatisierte Entscheidungsfindung</h2>
            <p>
              Es findet keine automatisierte Entscheidungsfindung oder ein Profiling im Sinne des Art. 22 DSGVO statt.
            </p>
          </div>

          <p className="text-sm text-sand-500 italic">
            Diese Erklärung wird bei wesentlichen Änderungen aktualisiert.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
